import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import { ActivityIndicator, Dimensions, Image } from "~/ui/primitives"
import ImagePicker from "~/ui/image-picker"
import { alertSuccess } from "~utils/alert"
import { ActionsSheet } from "~components/actions-sheet"
import useMorePageEffect from "~hooks/useMorePageEffect"
import { staticUrl } from "~utils"
import { basename } from "~utils/path"
import { useStores } from "~models"
import styled from '~/ui/styled'
import { Event, EventNames, FLAG_ACK, UserUpdateData } from "~proto"

const  width  = 300

const IMAGES = {
  placeholder: require("../../../assets/images/placeholder.jpg"),
}
const Overlay = styled.View`
  position: absolute;
  display: flex;
  left: 0px;
  top: 0px;
  z-index: 2;
  background-color: #eceaea;
  justify-content: center;
  align-items: center;
  opacity: 0.4;
`

const Avatar: React.FC = () => {
  const rootStore = useStores()
  const [imageUri, setImageUri] = useState("")
  const [imgErr, setImgErr] = useState(false)
  const [loading, setLoading] = useState(false)
  const [apiLoading, setApiLoading] = useState(false)
  const [actionsSheetVisible, setActionsSheetVisible] = useState(false)

  const handleOpenCameraPicker = async () => {
    const { path } = await ImagePicker.openCamera({
      cropping: true,
      useFrontCamera: true,
      freeStyleCropEnabled: true,
      loadingLabelText: "处理中...",
    })
    setImgErr(false)
    setImageUri(path)
    handleUpload(path)
  }

  const onOpenPicturePicker = async () => {
    const { path } = await ImagePicker.openPicker({
      cropping: true,
      multiple: false,
      mediaType: "photo",
      freeStyleCropEnabled: true,
      loadingLabelText: "处理中...",
    })
    setImgErr(false)
    setImageUri(path)
    handleUpload(path)
  }

  const handleUpload = async (path) => {
    const { apiStore } = rootStore
    try {
      setApiLoading(true)
      const { uri } = await apiStore.upload({ path, type: "image/jpeg", filename: basename(path) })
      handleUpdateUserAvatar(uri)
    } catch (e) {
      // console.warn(e)
    } finally {
      setApiLoading(false)
      setLoading(false)
    }
  }

  const handleUpdateUserAvatar = (uri) => {
    const evt = new Event<UserUpdateData>(EventNames.USER_UPDATE, {
      avatar: uri,
    })
    rootStore.eventStore.publish(evt, { flags: FLAG_ACK })
    setLoading(false)
    alertSuccess({ message: "上传成功" })
  }

  const onImageError = () => {
    setImgErr(true)
  }

  const onImageLoadStart = () => {
    setLoading(true)
  }

  const onImageLoadEnd = () => {
    setLoading(false)
  }

  let source = IMAGES.placeholder
  if (!imgErr) {
    const img = imageUri || staticUrl(rootStore.userStore.currentUser.avatar)
    if (img) {
      source = { uri: img }
    }
  }

  useMorePageEffect({
    onMoreButtonPress: () => setActionsSheetVisible(true),
  })

  const actionOptions = [
    { text: "拍照", onClick: handleOpenCameraPicker },
    { text: "从相册选一张", onClick: onOpenPicturePicker },
    { text: "取消" },
  ]

  return (
    <>
      <Image
        src={source}
        style={{ width, height: width,maxWidth: '100%',maxHeight: '100%' }}
        resizeMode="cover"
        onError={onImageError}
        onLoadStart={onImageLoadStart}
        onLoadEnd={onImageLoadEnd}
      />
      {loading || apiLoading ? (
        <Overlay style={{ width, height: width,maxWidth: '100%',maxHeight: '100%' }}>
          <ActivityIndicator color={"black"} size={48} />
        </Overlay>
      ) : null}

      <ActionsSheet
        visible={actionsSheetVisible}
        setVisible={setActionsSheetVisible}
        data={actionOptions}
      />
    </>
  )
}

export default observer(Avatar)
